export const subscriptionErrorParamName = 'se';

export const CLIENT_ID_PARAM = 'clientId';
export const REDIRECT_URI_PARAM = 'redirectUri';
export const STATE_PARAM = 'state';
export const B64_CODE_CHALLENGE_PARAM = 'b64CodeChallenge';
export const CODE_CHALLENGE_METHOD_PARAM = 'codeChallengeMethod';
export const APP_URL_PARAM = 'appUrl';
export const REQUESTED_PATH_PARAM = 'requestedPath';
export const GRANT_TYPE_PARAM = 'grantType';

export const MFA_CODE_PARAM = 'mfaCode';
export const MFA_CODE_SENT_TO_PARAM = 'mfaCodeSentTo';
export const MFA_TYPE_PARAM = 'mfaType';
export const MFA_FLOW_PARAM = 'mfaFlow';

export const PKCE_PARAM_NAMES = [
  CLIENT_ID_PARAM,
  REDIRECT_URI_PARAM,
  STATE_PARAM,
  B64_CODE_CHALLENGE_PARAM,
  CODE_CHALLENGE_METHOD_PARAM,
] as const;
